module.exports = __webpack_public_path__ + "files/4737f5324cd5ae58d85b014e893e0011.png";